
import { InputBase, InputDurationController } from "../../controllers";

import { Objects } from "@salaxy/core";

import { ComponentBase } from "../_ComponentBase";

/**
 * Shows a an editor / display component for a .Net Duration.
 * .Net Duration is a string in format "ddd.hh:mm:ss.ttttttt".
 * @example
 * ```html
 * <salaxy-input-duration name="myInput" ng-model="temp" label="Basic example"></salaxy-input-duration>
 * ```
 */

export class InputDuration extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",

    form: "?^^form",
};

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {});

  /** Uses the InputDurationController */
  public controller = InputDurationController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/InputDuration.html";
}
